/** @jsxImportSource @emotion/react */
import { ReactElement } from "react";
import theme from "../../../../theme";
import styles from "./styles";

interface IProps {
  width: number;
  progress: number;
  spin?: boolean;
}

const ProgressCircle = ({
  width,
  progress,
  spin = false,
}: IProps): ReactElement | null => {
  if (!width) return null;

  const thickness = 3;
  const radius = width / 2 - thickness / 2 - width * 0.001;
  const circumference = radius * 2 * Math.PI;

  return (
    <svg height={width} width={width} id="progress-circle">
      <circle
        css={[styles.circle].concat(spin ? [styles.animated] : [])}
        stroke={theme.colors.secondary.brightOrange}
        strokeWidth={thickness}
        fill="transparent"
        strokeDasharray={`${circumference} ${circumference}`}
        strokeDashoffset={circumference - circumference * progress}
        r={radius}
        cx={width / 2}
        cy={width / 2}
      />
    </svg>
  );
};

export default ProgressCircle;
